function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useCombineRef, useElementSize, useRefCallback, useRefGetter, useUncontrolledShow, useLockScroll } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { useConfig, useDirection, useLocale, usePrefixCls } from '@byte-design/config';
import { CloseSmall } from '../../common/icons';
import { LayerContext } from '../../context/layer';
import { Content } from '../util/Content';
import { RcDialog } from '../../units/dialog';
import { useModalHeight } from './useModalHeight';
import { InternalModalFooter } from './ModalFooter';
export var Modal = React.forwardRef(function (props, ref) {
  var _useConfig = useConfig(),
      lockScroll = _useConfig.lockScroll;

  var unsafeShow = props.show,
      children = props.children,
      header = props.header,
      footer = props.footer,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      _props$type = props.type,
      type = _props$type === void 0 ? 'normal' : _props$type,
      className = props.className,
      bodyStyle = props.bodyStyle,
      _props$closeable = props.closeable,
      closeable = _props$closeable === void 0 ? true : _props$closeable,
      _props$mask = props.mask,
      mask = _props$mask === void 0 ? true : _props$mask,
      afterClose = props.afterClose,
      _props$lazyInit = props.lazyInit,
      lazyInit = _props$lazyInit === void 0 ? true : _props$lazyInit,
      hideToDestroy = props.hideToDestroy,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? false : _props$maskClosable,
      maskStyle = props.maskStyle,
      footerRef = props.footerRef,
      onClose = props.onClose,
      onCancel = props.onCancel,
      onOk = props.onOk,
      _props$cancelButtonPr = props.cancelButtonProps,
      cancelButtonProps = _props$cancelButtonPr === void 0 ? {} : _props$cancelButtonPr,
      _props$okButtonProps = props.okButtonProps,
      okButtonProps = _props$okButtonProps === void 0 ? {} : _props$okButtonProps,
      cancelText = props.cancelText,
      okText = props.okText,
      width = props.width,
      height = props.height,
      top = props.top,
      _props$size = props.size,
      size = _props$size === void 0 ? 'sm' : _props$size,
      icon = props.icon,
      wrapperClassName = props.wrapperClassName,
      wrapperStyle = props.wrapperStyle,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      disableAnimation = props.disableAnimation,
      defaultShow = props.defaultShow,
      domRef = props.domRef,
      _props$keyboard = props.keyboard,
      keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
      extra = _objectWithoutProperties(props, ["show", "children", "header", "footer", "divider", "type", "className", "bodyStyle", "closeable", "mask", "afterClose", "lazyInit", "hideToDestroy", "maskClosable", "maskStyle", "footerRef", "onClose", "onCancel", "onOk", "cancelButtonProps", "okButtonProps", "cancelText", "okText", "width", "height", "top", "size", "icon", "wrapperClassName", "wrapperStyle", "style", "disableAnimation", "defaultShow", "domRef", "keyboard"]);

  var rtl = useDirection() === 'rtl';

  var _useUncontrolledShow = useUncontrolledShow({
    show: unsafeShow,
    defaultShow: defaultShow
  }),
      _useUncontrolledShow2 = _slicedToArray(_useUncontrolledShow, 2),
      show = _useUncontrolledShow2[0],
      setShow = _useUncontrolledShow2[1];

  var mountRef = useRef(show || !lazyInit);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      appearedCauseOfMotion = _useState2[0],
      setAppearedCauseOfMotion = _useState2[1];

  var elementRef = useRef(null);
  var contentRef = useRef(null);
  var internalRef = useRef(null);
  var combinedRef = useCombineRef(internalRef, domRef);
  var onOkCallback = useRefCallback(onOk);

  var handleCancel = function handleCancel() {
    var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (onCancel) return onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    onClose === null || onClose === void 0 ? void 0 : onClose(reason);
  };

  var onCancelCallback = useRefCallback(function () {
    handleCancel();
  });
  var localeCancel = useLocale('modal.cancel');
  var localeOk = useLocale('modal.ok');
  var okCls = usePrefixCls("".concat(type, "-ok"));
  var cancelCls = usePrefixCls("".concat(type, "-cancel"));
  var footerCls = usePrefixCls("".concat(type, "-footer"));

  var renderFooter = function renderFooter() {
    if (type !== 'normal' && footer === undefined) {
      var showCancelButton = type === 'confirm';
      return React.createElement(InternalModalFooter, {
        ref: footerRef,
        align: "end",
        className: footerCls,
        showCancelButton: showCancelButton,
        cancelButtonProps: cancelButtonProps,
        cancelButtonclassName: cancelCls,
        cancelText: cancelText || localeCancel,
        okButtonProps: okButtonProps,
        okButtonclassName: okCls,
        okText: okText || localeOk,
        onCancelCallback: onCancelCallback,
        onOkCallback: onOkCallback
      });
    }

    return footer;
  };

  useImperativeHandle(ref, function () {
    return {
      dom: internalRef.current,
      show: function show() {
        return setShow(true);
      },
      hide: function hide() {
        return setShow(false);
      }
    };
  }, [setShow]);
  var disableLeaveMotion = !!disableAnimation;
  var disableEnterMotion = disableAnimation === true;
  var shouldApplyEnterMotion = show && !appearedCauseOfMotion && !disableEnterMotion;
  var shouldApplyLeaveMotion = !show && appearedCauseOfMotion && !disableLeaveMotion;
  var isAppeared = show && (appearedCauseOfMotion || disableEnterMotion);
  var isDisplayed = show || appearedCauseOfMotion && !disableLeaveMotion;

  var handleEnterStart = function handleEnterStart() {
    if (shouldApplyEnterMotion) {
      setAppearedCauseOfMotion(true);
    }
  };

  var keyboardClose = useCallback(function (event) {
    if (keyboard && event.key === 'Escape') {
      handleCancel('keyboard');
    }
  }, []);

  var handleLeaveEnd = function handleLeaveEnd() {
    if (shouldApplyLeaveMotion) {
      mountRef.current = hideToDestroy ? false : mountRef.current;
      setAppearedCauseOfMotion(false);
      afterClose === null || afterClose === void 0 ? void 0 : afterClose();
    }
  };

  var handleIconClose = useRefCallback(function () {
    handleCancel('closeIcon');
  });
  var handleMaskClick = useRefCallback(function () {
    if (maskClosable) {
      handleCancel('mask');
    }
  });

  var _useLockScroll = useLockScroll(lockScroll),
      lock = _useLockScroll.lock,
      unlock = _useLockScroll.unlock;

  var disableLeaveMotionRefGetter = useRefGetter(disableLeaveMotion);
  useEffect(function () {
    show ? lock() : unlock();

    if (!show && disableLeaveMotionRefGetter()) {
      afterClose === null || afterClose === void 0 ? void 0 : afterClose();
    }

    if (show) {
      return unlock;
    }
  }, [show]);

  var _useModalHeight = useModalHeight(_objectSpread(_objectSpread({}, style), {}, {
    height: height == null ? style.height : height
  })),
      acturalHeight = _useModalHeight.height,
      containerResize = _useModalHeight.containerResize;

  useElementSize(internalRef, function () {
    return !!show;
  }, containerResize);
  var useDefaultLayout = acturalHeight === undefined;
  var bodyCls = usePrefixCls('modal-body', {
    flex: useDefaultLayout,
    fixedtop: top !== undefined
  });
  var wrapperCls = usePrefixCls('modal-wrapper', {
    rtl: rtl
  });
  var maskCls = usePrefixCls('modal-mask', {
    show: isAppeared,
    'event-none': useDefaultLayout
  });
  var contentCls = usePrefixCls('modal', {
    size: size,
    show: isAppeared,
    rtl: rtl
  });
  var closeIconCls = usePrefixCls('modal-close-icon');
  var outerScrollStyle = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    paddingTop: top,
    transform: ''
  };

  if (disableLeaveMotion && !show && hideToDestroy) {
    mountRef.current = false;
  } else if (!mountRef.current) {
    mountRef.current = !!show;
  }

  var handleClick = useCallback(function (event) {
    if (mask && useDefaultLayout && contentRef.current && contentRef.current === event.target) {
      handleMaskClick();
    }
  }, [mask, useDefaultLayout]);

  if (!mountRef.current) {
    return null;
  }

  return React.createElement(RcDialog, Object.assign({}, extra, {
    show: true,
    ref: combinedRef,
    contentRef: contentRef,
    className: bodyCls,
    horizontal: "center",
    onClick: handleClick,
    onMaskClick: handleMaskClick,
    mask: mask && !useDefaultLayout,
    maskClassName: maskCls,
    maskStyle: maskStyle,
    vertical: "center",
    wrapperClassName: classnames(wrapperCls, wrapperClassName),
    wrapperStyle: _objectSpread(_objectSpread({}, wrapperStyle), isDisplayed ? null : {
      display: 'none'
    }),
    style: _objectSpread(_objectSpread({}, !useDefaultLayout ? {} : outerScrollStyle), style),
    animation: {
      show: show,
      type: 'transition',
      validTarget: elementRef,
      validProperty: 'transform',
      disabled: disableEnterMotion && disableLeaveMotion,
      enter: {
        onStart: handleEnterStart
      },
      leave: {
        onEnd: handleLeaveEnd
      }
    },
    toBody: true,
    onKeyDown: keyboardClose
  }), mask && useDefaultLayout && React.createElement("div", {
    className: maskCls,
    style: _objectSpread({
      zIndex: 0,
      position: 'fixed'
    }, maskStyle)
  }), React.createElement(Content, {
    show: show,
    containerRef: elementRef,
    prefixCls: "modal-content",
    className: classnames(contentCls, className),
    style: _objectSpread({
      width: typeof width === 'string' ? width : width + 'px',
      height: !useDefaultLayout ? "".concat(acturalHeight, "px") : undefined
    }, bodyStyle),
    icon: icon,
    divider: divider,
    header: header,
    footer: renderFooter(),
    enableSize: show && !!height
  }, !!closeable && React.createElement(CloseSmall, {
    className: closeIconCls,
    onClick: handleIconClose
  }), React.createElement(LayerContext.Provider, {
    value: elementRef
  }, children)));
});
Modal.displayName = 'Modal';